<template>
  <v-dialog
    v-if="store && isOpen"
    content-class="map-custom-dialog"
    v-model="isOpen"
    :persistent="true"
  >
    <!-- loading modal -->
    <v-dialog v-model="requesting" content-class="v-custom-pro">
      <v-progress-circular
        :size="100"
        :width="9"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-dialog>
    <v-card>
      <div class="modal-left">
        <p class="green-title">Ihr gewählter Anbieter</p>
        <p class="left-subject-text">
          {{ store.storeName }}
        </p>
        <p class="left-address-text">{{ store.address.street }}</p>
        <p class="left-zipcode">
          {{ store.address.zip }} {{ store.address.city }}
        </p>
        <p class="green-title left-bottom">Ihre Anfrage</p>
        <div class="left-bottom-desc">
          <div class="left-subbottom">
            <img
              src="../../assets/images/Saved-products-icon.webp"
              class="bottom-icon"
              alt="Symbol „Rezept gesendet“"
            />
            <div v-if="data.products.length == 1" class="left-bottom-text">
              {{ data.products[0].userSuggestion }}
            </div>
            <div v-else-if="data.products.length == 2" class="left-bottom-text">
              {{ data.products[0].userSuggestion }},
              {{ data.products[1].userSuggestion }}
            </div>
            <div v-else-if="data.products.length > 2" class="left-bottom-text">
              {{ data.products.length }} Hilfsmittel
            </div>
          </div>
          <div
            v-if="JSON.stringify(data.insurance) != '{}'"
            class="left-subbottom"
          >
            <img
              src="../../assets/images/insurance-checkmark-icon-black.webp"
              class="bottom-icon"
              alt="Symbol „Rezept gesendet“"
            />
            <div class="left-bottom-text">
              {{ data.insurance.krankenkasse }}
            </div>
          </div>
          <div class="left-subbottom">
            <img
              src="../../assets/images/location-icon.webp"
              class="bottom-icon he-21x loc-wid"
              alt="Standortsymbol"
            />
            <div class="left-bottom-text">
              {{ data.address.userSuggestion }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-right">
        <img
          class="close-icon"
          src="../../assets/images/cross-icon.webp"
          alt="Schließen-Symbol"
          @click="cancel()"
        />
        <p v-if="!isSubmitted" class="right-title">
          Senden Sie jetzt eine unverbindliche Anfrage an den gewählten
          Anbieter, um Ihre Hilfsmittel zu erhalten.
        </p>
        <div v-if="!isSubmitted" class="right-body">
          <div class="right-des">
            <div class="right-subdes">
              <div class="subdes-icon">
                <img
                  src="../../assets/images/checkmark-icon-green.webp"
                  alt="Häkchen-Symbol"
                />
              </div>
              <div class="right-subdes-text">
                Antwort innerhalb von 24 Stunden
              </div>
            </div>
            <div class="right-subdes">
              <div class="subdes-icon">
                <img
                  src="../../assets/images/checkmark-icon-green.webp"
                  alt="Häkchen-Symbol"
                />
              </div>
              <div class="right-subdes-text">Persönliche Beratung</div>
            </div>
            <div class="right-subdes">
              <div class="subdes-icon">
                <img
                  src="../../assets/images/checkmark-icon-green.webp"
                  alt="Häkchen-Symbol"
                />
              </div>
              <div class="right-subdes-text">Kostenloser Service</div>
            </div>
          </div>
          <div class="right-form">
            <div class="right-subform">
              <div class="subform-element">
                <label>Vorname*</label>
                <v-text-field
                  v-model="firstName"
                  label=""
                  class="custom-form-desk-input"
                  height="39px"
                  :rules="rules.name"
                  single-line
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div class="subform-element">
                <label>Nachname*</label>
                <v-text-field
                  v-model="lastName"
                  label=""
                  class="custom-form-desk-input"
                  height="39px"
                  :rules="rules.name"
                  single-line
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div class="subform-element">
                <label>E-Mail*</label>
                <v-text-field
                  v-model="email"
                  label=""
                  class="custom-form-desk-input"
                  height="39px"
                  :rules="rules.email"
                  single-line
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div class="subform-element">
                <label>Telefonnummer*</label>
                <v-text-field
                  v-model="phoneNumber"
                  label=""
                  class="custom-form-desk-input"
                  height="39px"
                  :rules="rules.telephone"
                  single-line
                  outlined
                  dense
                ></v-text-field>
              </div>
            </div>
            <div class="right-subform right-subform-fit">
              <div class="subform-element">
                <label class="prescription-title"
                  >Haben Sie bereits ein Rezept für Ihre gewählten
                  Hilfsmittel?*</label
                >
                <v-radio-group v-model="radios" mandatory>
                  <v-radio label="Ja" value="yes"></v-radio>
                  <v-radio label="Nein" value="no"></v-radio>
                </v-radio-group>
              </div>
              <div class="subform-element">
                <label>Ihre Nachricht an den Anbieter</label>
                <v-textarea
                  v-model="message"
                  label=""
                  class="custom-form-desk-input"
                  height="136px"
                  single-line
                  outlined
                  dense
                ></v-textarea>
                <div class="end-label">* Pflichtfeld</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="right-body d-flex he-100">
          <div class="right-result">
            <div v-if="isSuccess" class="right-result-body">
              <div class="result-icon">
                <img
                  src="../../assets/images/checkmark-icon-green.webp"
                  alt="Häkchen-Symbol"
                />
              </div>
              <div class="right-result-text">
                <p>Ihre Anfrage wurde erfolgreich gesendet.</p>
                <p>Sie erhalten innerhalb von 24 Stunden eine Rückmeldung.</p>
              </div>
            </div>
            <div v-if="isSuccess" class="right-result-body">
              <!-- <div v-if="radios" class="prescription">
                               <div class="prescription-icon">
                                   <img  src="../../assets/images/Prescription-icon.webp"/>
                               </div>
                               <div class="prescription-t-b-body">
                                   <div class="prescription-text">
                                       <p>Sie möchten die Kostenübernahme vorab prüfen lassen?</p>
                                        <p>Reichen Sie jetzt Ihr Hilfsmittel-Rezept ein, sodass der Anbieter das Rezept vor der Beratung prüfen kann.</p>
                                   </div>
                                   <div class="prescription-btn">
                                       <button class="g-blue-btn">
                                           Rezept einreichen
                                       </button>
                                   </div>
                               </div>
                           </div>
                           <div v-else class="prescription">
                               <div class="prescription-icon">
                                   <img  src="../../assets/images/Prescription-icon.webp"/>
                               </div>
                               <div class="prescription-t-b-body">
                                   <div class="prescription-text">
                                       <p>Sie möchten für eine Kostenübernahme noch ein Rezept einholen?</p>
                                       <p>Sie erhalten ein Schreiben für den behandelnden Arzt,, der bei medizinischer Notwendigkeit die richtigen Rezepte für Ihre Hilfsmittel ausstellen kann. </p>
                                   </div>
                                   <div class="prescription-btn">
                                       <button class="g-blue-btn spin-p-btn-w" @click="generatePDF" ref="npmodal">
                                           <span class="button__text" v-if="!isDownloading">Rezept einholen</span>
                                       </button>
                                   </div>
                               </div>
                           </div> -->
            </div>
            <div v-else class="right-result-body">
              <div class="right-result-text">
                <p class="error-msg bold center">
                  {{ UI_CONSTANTS.requestErrTitle }}
                </p>
                <p class="error-msg">{{ UI_CONSTANTS.requestErrMsg }}</p>
                <p class="error-msg bold center">
                  {{ UI_CONSTANTS.requestNumber }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isSubmitted" class="right-footer">
          <div class="right-footer-content">
            <v-checkbox v-model="checkTerm"></v-checkbox>
            <p>
              Ich stimme den
              <a
                href="https://www.anni.care/datenschutz/"
                target="_blank"
                class="check-pterm"
                >Datenschutzbestimmungen</a
              >
              zu und bin mit der Weitergabe meiner Daten an den Anbieter
              einverstanden.
            </p>
          </div>
        </div>
        <button
          v-if="!isSubmitted && passed"
          class="g-blue-btn btn-absol"
          @click="sendRequest()"
        >
          Anfrage senden
        </button>
        <button
          v-else-if="!isSubmitted && !passed"
          class="g-disabled-btn btn-absol"
        >
          Anfrage senden
        </button>
        <button
          v-else-if="isSubmitted"
          class="g-blue-btn btn-absol"
          @click="cancel()"
        >
          Fenster schließen
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  isValidMail,
  isValidTel,
  isValidName,
} from "../../services/ValidationService";
import { createNewOrder } from "../../services/MainService";
import UI_CONSTANTS from "../../../uiConstants";
import { mapActions } from "vuex";
export default {
  props: {
    isOpen: Boolean,
    store: Object,
    data: Object,
    isSubmitted: Boolean,
  },
  data: () => ({
    rules: {
      email: [(input) => isValidMail(input) || UI_CONSTANTS.wrongEmail],
      name: [(input) => isValidName(input) || UI_CONSTANTS.wrongName],
      telephone: [(input) => isValidTel(input) || UI_CONSTANTS.wrongTelephone],
    },
    radios: true,
    isSuccess: false, // false
    passed: false,
    checkTerm: false,
    firstName: null,
    lastName: null,
    email: null,
    phoneNumber: null,
    message: null,
    requesting: false,
    UI_CONSTANTS: UI_CONSTANTS,
  }),
  methods: {
    ...mapActions(["recordInteraction"]),
    cancel() {
      this.formatData();
      this.$emit("closeNoPtRe", false);
    },
    async sendRequest() {
      this.requesting = true;
      let data = {
        customerDetails: {
          firstname: "",
          lastname: "",
          telephone: "",
          mail: "",
          city: "",
        },
        orderDetails: {
          products: [],
          insurance: "",
          message: "",
          prescriptionPresent: false,
          selectedProvider: {
            dataSrc: "",
            storeID: "",
          },
        },
      };
      data.customerDetails.firstname = this.firstName;
      data.customerDetails.lastname = this.lastName;
      data.customerDetails.mail = this.email;
      data.customerDetails.phone1 = this.phoneNumber;
      data.customerDetails.city = this.data.address.userSuggestion;
      data.orderDetails.message = this.message ? this.message : "";
      data.orderDetails.prescriptionPresent =
        this.radios == "yes" ? true : false;
      data.orderDetails.products = this.data.products.map((item) => item.id);
      data.orderDetails.insurance =
        JSON.stringify(this.data.insurance) == "{}"
          ? undefined
          : this.data.insurance.insuranceID.toString();
      data.orderDetails.selectedProvider.dataSrc = this.store.dataSrc;
      data.orderDetails.selectedProvider.storeID =
        this.store.storeID.toString();
      data.orderDetails.selectedProvider.chainID = "n/a";
      let result = await createNewOrder(data);
      this.isSubmitted = true;
      this.isSuccess = result.success;
      this.requesting = false;
      this.formatData();
      this.recordInteraction({
        eventType: "newInquiryPlaced",
        eventData: {
          listedPartner: false,
          typeOfInquiry: "writtenInquiry",
        },
      });
    },
    formatData() {
      this.isSubmitted = true;
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.phoneNumber = null;
      this.message = null;
      this.checkTerm = false;
      this.passed = false;
      this.radios = true;
    },
  },
  watch: {
    firstName(value) {
      console.log();
      if (
        isValidName(value) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    lastName(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(value) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    email(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(value) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    phoneNumber(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(value) &&
        this.checkTerm
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    checkTerm(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        value
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
  },
};
</script>
